import { useStore } from 'zustand';
import { useUnityBuildStore } from '../stores/store';

export const acceptedEstimateId = 'b3342685-859c-41cc-a84c-bd87c70bc815';

export const useLockBid = () => {
  const { selectedEstimate, selectedChangeOrder } = useStore(useUnityBuildStore);

  /**
   * Checks if the current estimate or change order is "accepted".
   * @returns True if the current estimate or change order is "accepted", false otherwise.
   */
  const lockBid = () => {
    return (
      selectedEstimate?.estimatestatusid === acceptedEstimateId ||
      selectedChangeOrder?.changeorderstatusid === acceptedEstimateId
    );
  };

  return { lockBid };
};
